<template v-if="user.hausType != null && user.hausType > 0">
  <div class="animated fadeIn" style="margin-top: 10px;">
    <!-- <div id="cover" style="position: fixed; height: 100%; width: 100%; top:0; left: 0; background: rgba(255, 255, 255, 0.8); z-index:9999;">
    <div style="color:white;position: absolute; margin: auto; top: 0; right: 0; bottom: 0; left: 0; width: 200px; height: 30px; border-radius: 3px;">
    <img class="navbar-brand-full" src="/static/img/preload.gif">
    </div>
    </div>-->
    <b-card v-if="locationId == 0">
      <div class="alert alert-success">
        <ul class="fa-ul" style="margin-bottom: 0px;">
          <li>
            <i class="fa fa-info-circle fa-li"></i>
            Please create location.
            <br />Click "Dropdown menu" (top right corner) > Click "
            <i class="nav-icon icon-plus"></i> More" >
            <i class="nav-icon icon-location-pin"></i> Location (left hand side menu)
          </li>
        </ul>
      </div>
    </b-card>
    <b-card v-if="user.hausType == 1 && locationId > 0 && unassignedLocks.length > 0">
      <b-row>
        <!-- <b-col sm="12" lg="6">
          <div class="alert alert-success">
            <ul class="fa-ul" style="margin-bottom: 0px;">
              <li>
                <i class="fa fa-info-circle fa-li"></i> Please assign following locks to location.
              </li>
            </ul>
          </div>
        </b-col>
        <b-col sm="12" lg="6" v-if="user.hausType == 1">
          <location-add-form></location-add-form>
        </b-col> -->
        
      </b-row>
      <div class="text-center text-muted">
        <b-row>
          <b-col sm="6" lg="3" v-for="nextItem in unassignedLocks" :key="nextItem.id">
            <lock-card :nextItem="nextItem"></lock-card>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-card no-body v-if="locationId > 0 && unassignedLocks.length == 0">
      <b-row>
        <location-card :location="location"></location-card>
        
      </b-row>
      <b-col cols="12" md="12" v-if="true">
        <b-tabs card>
          <b-tab title="Home" active>
            <b-row>
              <b-col cols="12" md="12">
                <locks-available></locks-available>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab
            :title="`${j.name}` +' ('+ `${j.locksCount }` + ')'"
            v-for="j in location.lockgroups"
            :key="j.id"
          >
            <b-row>
              <b-col cols="12" md="12">
                <locks-lockgroup
                  :locationId="location.id"
                  :lockGroupId="j.id"
                  :lockGroupName="j.name"
                ></locks-lockgroup>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-card>
    <location v-if="user.hausType == 1 && locationId > 0 && unassignedLocks.length > 0"/>
  </div>
</template>

<script>
import LocationCard from './base/haus/LocationCard'
import Location from './base/Location'
import Locks from './base/Locks'
import ManagerList from './base/ManagerList'
import ManagerForm from '@/views/base/ManagerForm'
import LockToLockGroupMapperForm from './base/LockToLockGroupMapperForm'
import ManagerAddForm from '@/views/base/ManagerAddForm'
import EkeyList from '@/views/base/haus/EkeyList'
import EkeyForm from '@/views/base/haus/EkeyForm'
import LockCard from '@/views/base/haus/LockCard'
import LocksAvailable from '@/views/base/haus/LocksAvailable'
import AllLocks from '@/views/base/haus/AllLocks'
import LocksLockgroup from '@/views/base/haus/LocksLockgroup'
import LockGroupForLocation from '@/views/base/haus/LockGroupForLocation'
import LocationAddForm from '@/views/base/LocationAddForm'
import Statistics from '@/views/base/haus/Statistics'

let qs = require('qs')

const constants = require('./base/shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API_DETAIL = BASE + '/api/locations/detail'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      accessToken: data.accessToken,
      authorization: data.accessToken
    },
    method: 'POST'
  }).then(res => res.json())
}

export default {
  name: 'dashboard',
  components: {
    LocationCard,
    Location,
    Locks,
    ManagerList,
    ManagerForm,
    LockToLockGroupMapperForm,
    ManagerAddForm,
    EkeyForm,
    EkeyList,
    LockCard,
    LocksAvailable,
    AllLocks,
    LocksLockgroup,
    LockGroupForLocation,
    LocationAddForm,
    Statistics
  },
  data: () => {
    return {
      location: null,
      locationId: -1,
      unassignedLocks: [],
      user: {},
      fields: {
        name: {
          label: 'Name'
        },
        description: {
          label: 'Description'
        },
        action: {
          label: 'Action'
        }
      },
      currentPage: 1,
      perPage: 5,
      totalRows: 0
      // filter: null
    }
  },
  mounted () {
    if (localStorage.getItem('token')) {
      this.user.hausType = localStorage.getItem('ouht')
      this.$data.locationId = localStorage.getItem('locationId')
      if (this.user.hausType > 0) { 
        let localLocationsList = localStorage.getItem('localLocationsList')
        if(localLocationsList === null || localLocationsList === 'undefined' ) {
          constants.gotoLogin()
        } else {
          
          //localLocationsList = localStorage.getItem('localLocationsList')

          localLocationsList = JSON.parse(localLocationsList)

          for(let i in localLocationsList) {
            let loopLocation = localLocationsList[i]
              if(this.$data.locationId == loopLocation.id) {
                this.$data.location = loopLocation
                if (loopLocation.owner != null && loopLocation.owner.name == null) {
                  
                  this.$data.location.owner.name = localStorage.getItem('name')
                }
                break                  
            }
          }
        }

        let localLocksList = localStorage.getItem('localLocksList')
        localLocksList = JSON.parse(localLocksList)
        
        this.unassignedLocks = localLocksList.filter(lock => lock.locationId == null)
      }
    } else {
      this.$router.push('/pages/login')
    }


  },
  methods: {
    openlink (link) {
      location.href = link
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Newport.vue